var _mask, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMailIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 24,
    viewBox: "0 0 24 24",
    width: 24,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "a",
    height: 24,
    maskUnits: "userSpaceOnUse",
    width: 24,
    x: 0,
    y: 0
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h24v24h-24z",
    fill: "#d9d9d9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m4 20c-.55 0-1.02083-.1958-1.4125-.5875s-.5875-.8625-.5875-1.4125v-12c0-.55.19583-1.02083.5875-1.4125s.8625-.5875 1.4125-.5875h16c.55 0 1.0208.19583 1.4125.5875s.5875.8625.5875 1.4125v12c0 .55-.1958 1.0208-.5875 1.4125s-.8625.5875-1.4125.5875zm8-7.175c.0833 0 .1708-.0125.2625-.0375s.1792-.0625.2625-.1125l7.075-4.425c.1333-.08333.2333-.1875.3-.3125s.1-.2625.1-.4125c0-.33333-.1417-.58333-.425-.75s-.575-.15833-.875.025l-6.7 4.2-6.7-4.2c-.3-.18333-.59167-.1875-.875-.0125s-.425.42083-.425.7375c0 .16667.03333.3125.1.4375s.16667.22083.3.2875l7.075 4.425c.0833.05.1708.0875.2625.1125s.1792.0375.2625.0375z",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailIcon);
export default __webpack_public_path__ + "static/media/mail-icon.0a439f530a7ef82499bf1bfa3a6c7f58.svg";
export { ForwardRef as ReactComponent };